import React, { useMemo } from "react";
import { DollarSign } from "lucide-react";
import { PROVIDER_LABELS } from "./constants";

export function TierEconomicsHint({ tier, rates }) {
    const lines = useMemo(() => {
        const credit_amount = Number(tier.credit_amount) || 0;
        if (!credit_amount) return [];
        return Object.entries(rates)
            .filter(([_, v]) => Number(v) > 0)
            .map(([k, v]) => {
                const callsPossible = Math.floor(credit_amount / Number(v));
                return {
                    provider: k,
                    label: PROVIDER_LABELS[k] || k,
                    callsPossible,
                    rate: Number(v),
                };
            });
    }, [tier, rates]);

    if (!lines.length) return null;
    const price = Number(tier.price_usd) || 0;
    const perCreditRevenue =
        Number(tier.credit_amount) > 0 ? price / Number(tier.credit_amount) : 0;
    return (
        <div className="mt-1 px-3 py-2 bg-[#0A1128]/70 border border-[#2A3655] rounded-sm">
            <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold mb-1.5 flex items-center gap-1">
                <DollarSign className="w-3 h-3" />
                Economics @ current rates
            </div>
            <div className="text-[11px] text-slate-300 mb-1">
                Revenue per credit:{" "}
                <span className="font-mono text-emerald-400">
                    ${perCreditRevenue.toFixed(4)}
                </span>
            </div>
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-400">
                {lines.map((l) => (
                    <span key={l.provider}>
                        <span className="text-white font-semibold">
                            {l.callsPossible.toLocaleString()}
                        </span>{" "}
                        × {l.label}{" "}
                        <span className="text-slate-500">
                            (@ {l.rate} cr/call)
                        </span>
                    </span>
                ))}
            </div>
        </div>
    );
}

// ----- User subscriptions management panel -----

